import React, { Component } from 'react';
import Nav from '../../Components/Nav/Nav';
import classes from './Practice.module.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
// import PhotoGrid from "react-photo-feed";
// import "react-photo-feed/library/style.css";
import File from '../../Components/File/File';
import Portfolio from '../../Components/Portfolio';
import Directory from '../../Components/Directory/Directory';
import Collection from '../../Components/Collection/Collection';
import axios from 'axios';
const { NODE_ENV } = process.env;

class Practice extends Component {
    constructor(props) {
        super(props);
    }
    debugger;
    state = {
        problems: {},
        title: this.props.title,
        error: null,
        url: this.props?.match?.url,
    }
    // componentWillMount() {

    // }

    componentDidMount() {
        let url;
        console.log(this.props)
        if(this.props.match){
            url = '/testDirectory/' + this.props.match.url.split('/').slice(2).join('%2F');
        } else  {
            url = NODE_ENV === 'development' ? '/gallery/practice' : '/gallery2/practice';
            // url = '/gallery/practice';
        }
        axios.get(url).then( response => {
            let collections = response.data;
            this.setState({
                ...this.state,
                problems: collections,
                content: collections?.content,
                files: collections?.files || [],
                error: false,
                title: collections.title,
            })
        } )
        .catch(error => {
            console.log('Error', error);
            this.setState({
                ...this.state,
                error: true,
            });
        });
    }



    // componentWillUpdate(nextProps, nextState) {

    // }

    render() {
        let myPracticePortfolio;
        let data = {
            projects: [],
        }
        if(this.state.files && !this.state.content && !this.state.problems?.images?.length){
                myPracticePortfolio = <Directory imagePath={this.state.url} url={this.state.url} header={this.state.title} files={this.state.files}/>
        } else if (this.state.content){
            myPracticePortfolio = <File content={this.state.content}/>
        } else {               
            let colls = this.state.problems;
            if(Object.keys(colls).length > 2){
                        let category = colls.name.split('/');
                        category = category[category.length-1];
                        data.projects = this.state.problems.images.map((item)=> {
                            let title = item.src.split('/');
                            title = title[title.length-1];
                            return {
                                title,
                                category,
                                image: item.thumb,
                            }
                        })
                    myPracticePortfolio = <Portfolio imagePath="../js/practice" header="Interview and coding questions/answers" data={data}/>
            }
        }

        // } else {
        //         if(this.state.content) 
        // }
        
        return (
            <Aux>
                <Nav />
                <div className={classes.Practice}>
                    {myPracticePortfolio}
                </div>
            </Aux>
        );
    }
}


export default Practice;